import {Fetch} from "../network/Fetch";
import {ServerHost} from "../config/Config";


export function checkStatus(uuid) {

    return new Fetch("GET", ServerHost + "/xkk/v1/api/order/" + uuid)
        .fetch();
}


export function order(paymentType,productType,operatorId, voucherType, phoneNumber, amount, deliveryType, membershipNumber, usernameSurname, email) {

    let body = {
        productType,
        operatorId,
        voucherType,
        phoneNumber,
        amount,
        paymentType,
        deliveryType,
        membershipNumber,
        usernameSurname,
        email
    };

    return new Fetch("POST", ServerHost + "/xkk/v1/api/order", body)
        .fetch();

}
